module.exports = __webpack_public_path__ + "img/asmnt.68018405.svg";